// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__BWOFX","disabled":"Checkbox_disabled__WpdNl","root":"Checkbox_root__a5tAt","indicator":"Checkbox_indicator__myB0F"};